export class ListTableContextsResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "nextToken",
            "baseName": "nextToken",
            "type": "string",
            "format": ""
        },
        {
            "name": "totalCount",
            "baseName": "totalCount",
            "type": "number",
            "format": ""
        },
        {
            "name": "tableContexts",
            "baseName": "tableContexts",
            "type": "Array<TableContextSummary>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListTableContextsResponse.attributeTypeMap;
    }
    constructor() {
    }
}
